import { dataQACommentSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQACommentSolid = /*#__PURE__*/createIcon(dataQACommentSolid)
export default IconQACommentSolid
